import { TokenDetailsForLoginRequest } from "@/central-atoms/everest-fleet-pwa/requests";
import { GetLoginDetailsResponse } from "@/central-atoms/everest-fleet-pwa/responses";
import LoginFlowService from "@/services/api/LoginFlowService";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

const fetchLoginTokenDetails = createAsyncThunk<GetLoginDetailsResponse, TokenDetailsForLoginRequest>(
  'token_details_for_login', 
  async (tokenBody, thunkApi) => {
    try {
      const token = localStorage.getItem("auth_token");
      const response = await LoginFlowService.fetchLoginTokenDetails(tokenBody, token);

      return response.data
    } catch (err: any) {
      return thunkApi.rejectWithValue(err.response.data)
    }
  }
)

type LoginDetails = {
  details: GetLoginDetailsResponse | null,
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
}

const initialState: LoginDetails = {
  details: null,
  status: 'idle'
};

const loginDetailsSlice = createSlice({
  name: "loginDetails",
  initialState,
  reducers: {
    resetLoginReducerState: () => initialState,
    setSoc: (state, action: PayloadAction<number>) => {
      if (state.details?.data.details.soc) {
        state.details.data.details.soc = action.payload;
      }
    },
    setOdometer: (state, action: PayloadAction<number>) => {
      if (state.details?.data.details.odo) {
        state.details.data.details.odo = action.payload;
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchLoginTokenDetails.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchLoginTokenDetails.fulfilled, (state, action) => {
        state.status = 'succeeded'
        // Add any fetched posts to the array
        state.details = action.payload;
      })
      .addCase(fetchLoginTokenDetails.rejected, (state, action) => {
        state.status = 'failed'
        state.details = action.payload as GetLoginDetailsResponse;
      })
  }
});

export const { resetLoginReducerState, setSoc, setOdometer } = loginDetailsSlice.actions;
export { fetchLoginTokenDetails } 
export default loginDetailsSlice.reducer;
